const SET_HIDDEN_FIELDS  = 'campaigns/summary/SET_HIDDEN_FIELDS'

export const types = {
  SET_HIDDEN_FIELDS
}

export const setHiddenFields = (hiddenFields) => ({ type: SET_HIDDEN_FIELDS, hiddenFields })
